/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { JwtModule } from '@auth0/angular-jwt';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbThemeModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import { AuthGuard } from './auth/auth-guard.service';
import { LightboxModule } from 'ngx-lightbox';
import { ErrorHandlerModule } from './@core/error/error-handler.module';
import { RefreshTokenInterceptor } from './auth/refresh-token-interceptor';
import { SsoStepUpInterceptor } from './auth/sso-step-up-interceptor';
import { ParentInfoGuard } from './guards/parent-info.guard';

export function getBearerToken() {
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    EditorModule,
    LightboxModule,
    /* JwtModule.forRoot({
      config: {
        tokenGetter: getBearerToken,
        allowedDomains: [
          'localhost:1543',
          'rackcoachmobiletest.azurewebsites.net',
          '192.168.1.133:1543',
          'rackskintest.azurewebsites.net',
          'weightroom.rackperformance.com',
          'rack2-staging.azurewebsites.net',
          'test.rack.coach',
          'app.rackcoach.com'
        ],
        disallowedRoutes: [],
        skipWhenExpired: true
      }
    }), */
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbThemeModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ErrorHandlerModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    {
      // #80: launch native step-up on a 403 sso_step_up_required (#78 API rail).
      provide: HTTP_INTERCEPTORS,
      useClass: SsoStepUpInterceptor,
      multi: true,
    },
    AuthGuard,
    ParentInfoGuard,
    NbDatepickerModule,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
